import { FC } from 'react';

import { BugoBrand, BugoBrandData } from '@shared/api/bugoBrand/bugoBrand.interface';
import Modal from '@shared/components/Modal';

import { AdminBugoBrandAgencyWorkerBulkForm } from '../containers/AdminBugoBrandAgencyWorkerBulkForm/AdminBugoBrandAgencyWorkerBulkForm';

//*관리자가 같은 지사 지도사 계정을 한 번에 발급할때 사용하는 모달
interface Props {
  openId: string;
  bugoBrand: BugoBrand | BugoBrandData;
}

export const AdminAgencyWorkerBulkCreateModal: FC<Props> =
  function AdminAgencyWorkerBulkCreateModal({ openId, bugoBrand }: Props) {
    return (
      <Modal openId={openId} className="w-full sm:max-w-[760px]">
        <AdminBugoBrandAgencyWorkerBulkForm bugoBrand={bugoBrand} />
      </Modal>
    );
  };
